import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import LatestUpdates from "./components/LatestUpdates";
import PopularRecommend from "./components/PopularRecommend";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <div className="w-full">
      <h1 className="sr-only">韩漫免费漫画在线观看阅读双女主 - 高清免费漫画资源平台</h1>
      <HeroCarousel />
      <CategoryQuickLinks />
      <LatestUpdates />
      <PopularRecommend />
      <SiteIntro />
    </div>
  );
}